import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type SmartProposalStoreState
 */
const initialState = {
  fetchProposalDetail: { loading: false, data: null, error: null },
  acceptProposalDetail: { loading: false, data: null, error: null },
  updateTimeView: { loading: false, data: null, error: null },

};

export const BusinessProposalSlice = createSlice({
  name: "businessProposal",
  initialState,
  reducers: {
    fetchProposalDetailRequest: (state, action) => {
      state.fetchProposalDetail.loading = true;
      state.fetchProposalDetail.error = null;
    },
    fetchProposalDetailSuccess: (state, action) => {
      state.fetchProposalDetail.data = action.payload;
      state.fetchProposalDetail.loading = false;
      state.fetchProposalDetail.error = null;
    },
    fetchProposalDetailFailure: (state, action) => {
      state.fetchProposalDetail.data = null;
      state.fetchProposalDetail.loading = false;
      state.fetchProposalDetail.error = action.payload;
    },
    acceptProposalDetailRequest: (state, action) => {
      state.acceptProposalDetail.loading = true;
      state.acceptProposalDetail.error = null;
    },
    acceptProposalDetailSuccess: (state, action) => {
      state.acceptProposalDetail.data = action.payload;
      state.acceptProposalDetail.loading = false;
      state.acceptProposalDetail.error = null;
    },
    acceptProposalDetailFailure: (state, action) => {
      state.fetchProposalDetail.data = null;
      state.fetchProposalDetail.loading = false;
      state.fetchProposalDetail.error = action.payload;
    },

    updateViewTimeRequest: (state, action) => {
      state.updateTimeView.loading = true;
      state.updateTimeView.error = null;
    },
    updateViewTimeSuccess: (state, action) => {
      state.updateTimeView.data = action.payload;
      state.updateTimeView.loading = false;
      state.updateTimeView.error = null;
    },
    updateViewTimeFailure: (state, action) => {
      state.updateTimeView.data = null;
      state.updateTimeView.loading = false;
      state.updateTimeView.error = action.payload;
    },
  },
});



export const {
  fetchProposalDetailRequest,
  fetchProposalDetailSuccess,
  fetchProposalDetailFailure,
  acceptProposalDetailRequest,
  acceptProposalDetailSuccess,
  acceptProposalDetailFailure,
  updateViewTimeRequest,
  updateViewTimeSuccess,
  updateViewTimeFailure

} = BusinessProposalSlice.actions;

/**
 *
 * @param {*} state
 * @returns {SmartProposalStoreState}
 */
export const getBusinessProposalState = (state) => {
  return state.publicProposal;
};

export default BusinessProposalSlice.reducer;
